import { FC } from 'react';
import { usePatronSelector } from '../../../../../common/use-patron-selector';
import useScreenSize from '../../../../../common/use-screen-size';
import { getChannelById } from '../../../../../models/channels/selectors';
import { Sidebar } from '../../sidebar';
import styles from './styles.module.scss';

interface Props {
  activeTabId: number;
  topicId: string;
}
export const BaseTab: FC<Props> = ({ children, activeTabId, topicId }) => {
  const topic = usePatronSelector((state) => getChannelById(state, topicId));
  const { isTabletOrLarger } = useScreenSize();

  const previews = topic?.landing_page_previews;
  const enabledPreviews =
    previews?.modules?.filter((module) => module.enabled) || [];

  const anyPreviewsToShow =
    previews && previews.enabled && enabledPreviews.length > 0;

  const firstTabValue = topic?.landing_page_tabs.length
    ? topic.landing_page_tabs[0].id
    : null;

  // First tab is "home" and should have preview cards for all other tabs
  // we also only display the previews on tablet or larger screen sizes
  const hasPreview =
    activeTabId === firstTabValue && isTabletOrLarger && anyPreviewsToShow;

  return (
    <div className={styles.container}>
      <div className={hasPreview ? styles.content : styles.contentNoSidebar}>
        {children}
      </div>
      {hasPreview && previews && (
        <Sidebar
          topicId={topicId}
          currentTabId={activeTabId || firstTabValue || 0}
          landingPagePreviews={previews}
          tabs={topic.landing_page_tabs}
        />
      )}
    </div>
  );
};
